import {
  connectBaseApi,
  createRpcQuery,
  createRpcMutation,
  pickupLocationClient,
} from "@racoon/api";

export const pickupLocationApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listPickupLocationPhotos: createRpcQuery(build, pickupLocationClient, "listPickupLocationPhotos", {
        providesTags: ["PickupLocation"],
      },),
    // Id-scoped so a container-group edit can refresh the lists alone, without
    // dragging every photo and by-id query along with them.
    listPickupLocations: createRpcQuery(build, pickupLocationClient, "listPickupLocations", {
      providesTags: [{ type: "PickupLocation" as const, id: "LIST" }],
    }),
    getPickupLocationById: createRpcQuery(build, pickupLocationClient, "getPickupLocationById", {
      providesTags: ["PickupLocation"],
    }),
    createPickupLocation: createRpcMutation(build, pickupLocationClient, "createPickupLocation", {
      invalidatesTags: ["PickupLocation"],
    }),
    updatePickupLocation: createRpcMutation(build, pickupLocationClient, "updatePickupLocation", {
      invalidatesTags: ["PickupLocation"],
    }),
    deletePickupLocation: createRpcMutation(build, pickupLocationClient, "deletePickupLocation", {
      invalidatesTags: ["PickupLocation"],
    }),
    // Replace-set of the location's BY_NORM contracts: send the whole list, not a delta.
    setPickupLocationContracts: createRpcMutation(
      build,
      pickupLocationClient,
      "setPickupLocationContracts",
      { invalidatesTags: ["PickupLocation", "Contracts"] },
    ),
    bindPickupLocationListToContract: createRpcMutation(
      build,
      pickupLocationClient,
      "bindPickupLocationListToContract",
      { invalidatesTags: ["PickupLocation", "Contracts"] },
    ),
  }),
  overrideExisting: false,
});

export const {
  useListPickupLocationPhotosQuery,
  useListPickupLocationsQuery,
  useLazyListPickupLocationsQuery,
  useGetPickupLocationByIdQuery,
  useLazyGetPickupLocationByIdQuery,
  useCreatePickupLocationMutation,
  useUpdatePickupLocationMutation,
  useDeletePickupLocationMutation,
  useSetPickupLocationContractsMutation,
  useBindPickupLocationListToContractMutation,
} = pickupLocationApi;
